import { z } from 'zod';
/**
 * The company this deployment belongs to: buyer on every purchase invoice and
 * orderer on every purchase order.
 *
 * The values live in the API's environment, not here, so that re-pointing a
 * deployment is a config change rather than a rebuild — and so the invoice
 * rendered on screen and the order sent to a merchant cannot disagree about
 * the NIP. Nothing in the app lets a user edit them.
 */
export const companySchema = z.object({
    name: z.string(),
    nip: z.string(),
    street: z.string(),
    postalCode: z.string(),
    city: z.string(),
});
/** "32-800 Brzesko" — the second line of a Polish postal address. */
export function formatCityLine(place) {
    return `${place.postalCode} ${place.city}`.trim();
}
/** 869-141-85-67 — how a Polish NIP is written on a document. */
export function formatNip(nip) {
    if (!nip)
        return '—';
    const digits = nip.replace(/\D/g, '');
    if (digits.length !== 10)
        return nip;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`;
}
//# sourceMappingURL=company.js.map